module.exports = __webpack_public_path__ + "img/pinggu_icon0.4dd9aedb.png";